<header class="with-beefburger">
  <h1>
    Kyloe AwesomeDocs Manager
    @if (identity) {
      <span
        >for <span>{{ identity.namespace }}</span></span
        >
      }
    </h1>

  <div class="right-container">
    <div class="pendo-header-container"></div>
      @if (identity) {
        <span class="tenant-name" [matTooltip]="'Logged in with tenant: ' + identity.tenant" matTooltipShowDelay="500">
          <mat-icon fontIcon="people"></mat-icon>
          {{ identity.tenant }}
        </span>
      }

      <a
        href="http://www.KyloePartners.com"
        target="_blank"
        class="kyloe-logo-mask white overlay-darker-purple"
        [matTooltip]="'Visit our website'"
        matTooltipShowDelay="500"
        appRipple
      ></a>
  </div>
</header>
